import React from 'react';
import useAuth from '../hook/useAuth';
import { FontWeightType, LabelSmall } from './Text';

export const LogOutTextButton:React.FC = () => {
  const { logoutUser } = useAuth();
  return (
    <div
      style={{
        cursor: 'pointer',
        justifyContent: 'center',
        display: 'flex',
      }}
      onClick={logoutUser}
    >
      <LabelSmall
        style={{
          color: '#333333', textDecorationColor: '#333333', textDecoration: 'underline', fontFamily: 'inter',
        }}
        fontWeight={FontWeightType.w800}
      >
        로그아웃
      </LabelSmall>
    </div>
  );
};
